import _ from 'lodash'
const BUSINESS_THYRISTOR_CONFIG = {
    section: _.select( '.c-section--business-semiconductors-solutions-product-thyristor' )
}

export default BUSINESS_THYRISTOR_CONFIG